import { Flex, Heading, Icon, Button } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorIcon from '@/assets/icons/ic-error.svg';

import { IBugsnagFallbackComponentProps } from '@/types/bugsnag';

export const ErrorFallback: FC<IBugsnagFallbackComponentProps> = ({ clearError }) => {
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center" h="full" p={6}>
      <Icon as={ErrorIcon} color="red.600" width="64px" height="64px" />
      <Heading fontSize="md" my={4} textAlign="center" fontWeight="semibold">
        {t('directMessaging.error')}
      </Heading>
      <Button variant="solid" colorScheme="black" size="sm" onClick={clearError}>
        {t('directMessaging.errorButtonLabel')}
      </Button>
    </Flex>
  );
};
